import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IIdeaGenQuery, IIdeaGenSnapshotResponse } from '../../../core/models/idea-generation.model';

@Injectable({
  providedIn: 'root'
})
export class IdeaGenerationServiceService {

  constructor(private http: HttpClient) { }

  getSnapshot(query: IIdeaGenQuery): Observable<HttpResponse<IIdeaGenSnapshotResponse>> {
    return this.http.post<IIdeaGenSnapshotResponse>(
      '/backend/thematicView/idea-generation/snapshot',
      query,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('current_user_token')
        },
        observe: 'response',
        responseType: 'json'
      }
    );
  }
}
